import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import type { ModerationDetail } from '../types';
import type { ModerationActions } from '../hooks/useModerationActions';
import { PersonCard, type PersonExtraRow } from '../components/PersonCard';
import { formatDateTime } from '../lib/display';

/**
 * USER variant card (doc 09 §4.2/§4.5). Renders the reported user's profile (via the shared PersonCard)
 * plus the user-group extras (pricePerMonth / registeredAt / lastLogin). The single Ban/Unban toggle
 * lives in the action panel, driven by `report.reportedUserStatus` (ACT -> "Ban", TER -> "Unban").
 */
export function UserVariantCard({ report }: { report: ModerationDetail; actions: ModerationActions }) {
  if (report.kind !== 'USER') return null;
  const { reportedUser, user } = report;

  if (!reportedUser) {
    return (
      <Card>
        <CardHeader>
          <CardTitle className="text-sm">Reported User</CardTitle>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground">Reported user is unavailable.</p>
        </CardContent>
      </Card>
    );
  }

  const extra: PersonExtraRow[] = [];
  if (user.pricePerMonth) extra.push({ label: 'Price / Month', value: user.pricePerMonth });
  if (user.registeredAt) extra.push({ label: 'Registered', value: formatDateTime(user.registeredAt) });
  if (user.lastLogin) extra.push({ label: 'Last Login', value: formatDateTime(user.lastLogin) });

  return <PersonCard title="Reported User" person={reportedUser} extra={extra} />;
}
